import React, { Fragment, useMemo } from "react";
import HeaderBotton from "../../../components/HeaderBottom";
import HeaderTop from "../../../components/HeaderTop";
import HeroSlider from "../../../components/HeroSlider";
import Service from "../../../components/Service";
import About from "../../../components/About";
import ServiceArea from "../../../components/ServiceArea";
import Portfolio from "../../../components/Portfolio";
import Testmonial from "../../../components/Testmonial";
import ContactArea from "../../../components/ContactArea";
import TeamMember from "../../../components/TeamMember";
import CounterArea from "../../../components/CounterArea";
// import BlogArea from "../../../components/BlogArea";
import NewsLetter from "../../../components/Newsletter";
import FooterArea from "../../../components/FooterArea";
// images
import about from "../../../images/about/2.jpg";
import signature from "../../../images/about/1.png";

// images
import portfolio1 from "../../../images/studies/1.jpg";
import portfolio2 from "../../../images/studies/2.jpg";
import portfolio3 from "../../../images/studies/3.jpg";
import portfolio4 from "../../../images/studies/4.jpg";
import portfolio5 from "../../../images/studies/5.jpg";
import { PRACTICES } from "../../../utils/helpers";

const aboutText = [
  {
    text: "Our practice is built around a broad range of legal disciplines, including commercial law, real estate and property matters, commercial and general litigation, personal injury claims, employment issues, family law, insolvency, business advisory work, and private immigration services. We are a leading English law firm that also delivers Sharia compliant solutions alongside our conventional legal offerings.",
  },
  {
    text: "We advise a wide spectrum of clients, from private individuals and families to emerging businesses, retail operators, private and listed companies, partnerships, asset management firms, hospitality groups, telecommunications providers, academic institutions, offshore entities, and diplomatic missions. Our client base also includes Middle Eastern royalty, well known figures in the beauty and commercial sectors, as well as charitable and nonprofit organizations.",
  },
];

const heroSliders = [
  {
    images: "slideWrapperOne",
    title: "Providing tailored solutions in corporate law, litigation,",
    subTitle: "and dispute resolution",
    text: "",
    button: "Contact us now",
    imageUrl:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767209132/sarbens-banner2_rzwftl.jpg",
  },
  {
    images: "slideWrapperTwo",
    title: "Navigating Complexity,",
    subTitle: "Delivering Clarity",
    text: "",
    button: "Contact us now",
    imageUrl:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767209128/sarbens-banner_i8qpel.jpg",
  },
];

const services = [
  {
    icon: "flaticon-parents",
    title: "Family Law",
    content: "",
  },
  {
    icon: "flaticon-wounded",
    title: "Personal Injury",
    content: "",
  },
  {
    icon: "flaticon-employee",
    title: "Business Law",
    content: "",
  },
  {
    icon: "flaticon-thief",
    title: "Criminal Law",
    content: "",
  },
  {
    icon: "flaticon-university-graduate-hat",
    title: "Education Law",
    content: "",
  },
  {
    icon: "flaticon-house",
    title: "Real Estate Law",
    content: "",
  },
];

const portfolioItem = [
  { images: portfolio1, title: "General Service", subtitle: "Corporate" },
  { images: portfolio2, title: "Personal Issue", subtitle: "General" },
  { images: portfolio3, title: "Business Accounting", subtitle: "Business" },
  { images: portfolio4, title: "Accounting issue", subtitle: "Criminal" },
  {
    images: portfolio5,
    title: "Business Accounting",
    subtitle: "Family Issue",
  },
];

const HomePageOne = () => {
  const ss = useMemo(
    () =>
      PRACTICES.map((p) => ({
        icon: "flaticon-employee",
        title: p.title,
        content: "",
        url: `/practice-details/${p.url}`,
      })),
    [],
  );

  return (
    <Fragment>
      <header className="headerArea">
        <HeaderTop className="headerTop" />
        <HeaderBotton className="headerBottomArea" />
      </header>
      <HeroSlider sliders={heroSliders} className="heroSliderArea" />
      <Service className="serviceArea" />
      <About
        className="aboutArea"
        title="Overview"
        images={about}
        signature={signature}
        pragraphs={aboutText}
      />
      <ServiceArea
        className="ourServiceArea"
        title="How Can We Help You"
        subTitle="Our Practices"
        services={ss}
      />
      {/* <Portfolio
        className="portfolioArea"
        title="Our Resent Case Studies"
        subTitle="Here Our Best Work"
        portfolioItem={portfolioItem}
      /> */}
      <Testmonial className="testmonialArea" />
      <ContactArea className="contactArea" />
      <TeamMember
        title="Qualified Attorneys "
        subTitle="Meet Our Experts"
        className="teamArea"
        slider={true}
      />
      <CounterArea className="counterArea" />
      {/* <BlogArea
        className="blogArea"
        title="Latest News"
        subTitle="From Our Blog
                "
      /> */}
      <NewsLetter className="newsLetterArea" />
      <FooterArea />
    </Fragment>
  );
};
export default HomePageOne;
